/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateAuthorizationPropertyResponse
 */
export interface UpdateAuthorizationPropertyResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateAuthorizationPropertyResponse
     */
    correlationId: string;
}

/**
 * Check if a given object implements the UpdateAuthorizationPropertyResponse interface.
 */
export function instanceOfUpdateAuthorizationPropertyResponse(value: object): value is UpdateAuthorizationPropertyResponse {
    if (!('correlationId' in value) || value['correlationId'] === undefined) return false;
    return true;
}

export function UpdateAuthorizationPropertyResponseFromJSON(json: any): UpdateAuthorizationPropertyResponse {
    return UpdateAuthorizationPropertyResponseFromJSONTyped(json, false);
}

export function UpdateAuthorizationPropertyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAuthorizationPropertyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'correlationId': json['correlationId'],
    };
}

export function UpdateAuthorizationPropertyResponseToJSON(json: any): UpdateAuthorizationPropertyResponse {
    return UpdateAuthorizationPropertyResponseToJSONTyped(json, false);
}

export function UpdateAuthorizationPropertyResponseToJSONTyped(value?: UpdateAuthorizationPropertyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'correlationId': value['correlationId'],
    };
}

